import DatePicker from "../../../components/Misc/DatePicker";
import Select from "../../../components/UIElements/Select";
import { useSelector } from "react-redux";
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select as MultiSelect,
} from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomSelect from "../../../components/UIElements/CustomSelect";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AccountSearchModal = ({ onChange, formData, onCancel, onSubmit }) => {
  const { user } = useSelector((state) => state.user);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onChange({
      target: {
        name: "tags",
        value,
      },
    });
  };
  let { tags } = useSelector((state) => state.account);
  const { sites } = useSelector((state) => state.account);
  if (tags == null) tags = [];
  const renderValue = (selected) => {
    if (selected.length === 0) return "Select tags";
    let result = "";
    let count = 0;
    for (let i = 0; i < selected.length; i++) {
      if (result.length + selected[i].length <= 30) {
        result += result.length > 0 ? `, ${selected[i]}` : selected[i];
      } else {
        count++;
      }
    }
    return `${result} ${count > 0 ? "and +" + count + " more" : ""}`;
  };

  const renderOption = (props, option) => {
    const { active, description, league, thumbnails } = option;
    delete props.key;
    return (
      <div className="bg-gray flex items-center" key={props.id} {...props}>
        {thumbnails ? (
          <img width={20} src={thumbnails["48x48"]} />
        ) : (
          <Icon icon="material-symbols:globe" className="text-xl" />
        )}
        <p className="ml-2">
          {description}
          <span className="ml-3 text-sm text-warning">{league}</span>
        </p>
        <p
          className={`ml-auto text-sm text-${active === true ? "primary" : "danger"
            }`}
        >
          {active === true ? "Active" : "Inactive"}
        </p>
      </div>
    );
  };
  const getOptionLabel = (option) => {
    return option.description;
  };

  return (
    <div className="md:px-17.5 w-full max-w-230 rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:py-15">
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full  xl:2-1/2 flex items-end">
          <CustomSelect
            options={sites}
            renderOption={renderOption}
            getOptionLabel={getOptionLabel}
            onChange={onChange}
            label="Select a Site"
            name="site_id"
          />
        </div>
        <div className="w-full  xl:2-1/2">
        <Select
            value={formData.bad_creds || false}
            name="bad_creds"
            options={[
              { name: "Yes", value: true },
              { name: "No", value: false },
            ]}
            label="Bad Credentials"
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full  xl:2-1/2">
          <label className="mb-3 block text-black dark:text-white">
            Search term that filters (site, username, etc.)
          </label>
          <input
            type="text"
            value={formData.search_term}
            name="search_term"
            onChange={onChange}
            placeholder="Search Term"
            className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent py-3 px-5 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
          />
        </div>
        {user.role === "admin" && (
          <div className="w-full xl:2-1/2">
            <label className="mb-2 block text-black dark:text-white">
              Tags
            </label>
            <FormControl
              sx={{ m: 1, width: "100%" }}
              className="form-control !m-0 !text-white"
            >
              {tags && (
                <MultiSelect
                  labelId="multi-select"
                  id="multiselect"
                  multiple
                  value={formData.tags}
                  onChange={handleChange}
                  renderValue={renderValue || "Select Tags"}
                  MenuProps={MenuProps}
                >
                  {tags.length > 0 ? (
                    tags.map((tag) => (
                      <MenuItem key={tag} value={tag}>
                        <Checkbox checked={formData.tags && formData.tags.includes(tag)} />
                        <ListItemText primary={tag} />
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled={true}>
                      Getting Tags, wait a moment ...
                    </MenuItem>
                  )}
                </MultiSelect>
              )}
            </FormControl>
          </div>
        )}
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/2">
          <label className="mb-2.5 block text-black dark:text-white">
            Vendor ID
          </label>
          <input
            type="text"
            name="vendor_id"
            value={formData.vendor_id}
            onChange={onChange}
            placeholder="vendor_id - Vendor ID"
            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
          />
        </div>

        <div className="w-full xl:w-1/2">
          <Select
            value={formData.auto_created}
            name="auto_created"
            options={[
              { name: "Yes", value: true },
              { name: "No", value: false },
            ]}
            label="Auto Created"
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/2">
          <DatePicker
            label="Password auto update date no earlier than"
            value={formData.password_auto_updated_at}
            onChange={onChange}
            name="password_auto_updated_at"
          />
        </div>

        <div className="w-full xl:w-1/2">
          <DatePicker
            label="Search for accounts inserted at no earlier than"
            value={formData.inserted_at}
            onChange={onChange}
            name="inserted_at"
          />
        </div>
      </div>
      <div className="-mx-3 flex flex-wrap gap-y-4">
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onCancel}
            className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
          >
            Cancel
          </button>
        </div>
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onSubmit}
            className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90"
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};
export default AccountSearchModal;
